import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "./ui/accordion";
import { Reveal, Chapter } from "./Reveal";

const faqs = [
  {
    q: "How fast is Freshly, really?",
    a: "Our average delivery lands in 20–30 minutes. Dedicated pickers start on your order instantly and hand off to a driver who's already waiting — no batching, no detours.",
  },
  {
    q: "Where in Calgary do you deliver?",
    a: "We're live across central Calgary — Downtown, Beltline, Mission, Kensington, Bridgeland and Brentwood — with new neighbourhoods added every month.",
  },
  {
    q: "Who picks my groceries?",
    a: "Trained in-store pickers who shop the way you would. They check ripeness, dates and quality on every item, and text you instantly if a substitution is needed.",
  },
  {
    q: "What does delivery cost?",
    a: "A flat $3.99 delivery fee on orders over $35, with no surge pricing — ever. Freshly members pay $0 delivery on every order.",
  },
  {
    q: "How do I become a driver or picker?",
    a: "Apply through the 60-second form above. If you have a bike, car or just quick feet, we'll get you onboarded and earning within a week.",
  },
];

export const Faq = () => (
  <section
    id="faq"
    className="mx-auto max-w-[1400px] px-6 py-24 md:px-12 lg:py-36"
  >
    <div className="grid grid-cols-1 gap-16 lg:grid-cols-12">
      <Reveal className="lg:col-span-5">
        <Chapter number="06" label="Questions" />
        <h2 className="mt-6 font-syne text-4xl font-extrabold leading-[1.02] tracking-tighter text-forest sm:text-5xl">
          Asked,
          <br />
          <span className="text-fresh">answered.</span>
        </h2>
        <p className="mt-6 max-w-sm text-base leading-relaxed text-forest/60">
          Still curious? Reach us anytime at{" "}
          <span className="font-semibold text-forest">support@freshlydeliveries.click</span>
        </p>
      </Reveal>
      <Reveal delay={0.15} className="lg:col-span-7">
        <Accordion
          type="single"
          collapsible
          data-testid="faq-accordion"
          className="w-full"
        >
          {faqs.map((f, i) => (
            <AccordionItem
              key={f.q}
              value={`item-${i}`}
              data-testid={`faq-item-${i}`}
              className="border-forest/10"
            >
              <AccordionTrigger
                data-testid={`faq-trigger-${i}`}
                className="py-6 text-left font-syne text-lg font-bold text-forest transition-colors hover:text-fresh hover:no-underline md:text-xl"
              >
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="pb-6 text-sm leading-relaxed text-forest/60 md:text-base">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  </section>
);
